import { Col, Inset, ListEmpty, ListRow, PageBody, Row, Text } from "@rally/ui-kit";
import { useCallback, useEffect, useState } from "react";
import { Feed } from "../feed/feed.tsx";
import { say } from "../localization/say.ts";
import { WhenLabel } from "../localization/when-label.tsx";
import { act, read } from "../net/rally.ts";
import { goTo } from "../router.ts";

type PersonalConversation = { id: string; title: string | null; lastAt: string | null };
type WhereIAm = { personal: PersonalConversation[] };

export function PersonalScreen() {
  const [mine, setMine] = useState<PersonalConversation[] | null>(null);

  const again = useCallback(() => {
    void read<WhereIAm>("where.i.am")
      .then((where) => setMine(where.personal))
      .catch(() => setMine([]));
  }, []);
  useEffect(again, [again]);

  const start = async (): Promise<void> => {
    try {
      const made = await act<{ id: string }>("conversation.create", {});
      again();
      goTo(`/c/${made.id}`);
    } catch {}
  };

  return (
    <PageBody testID="personal-screen">
      <Col>
        <Text typeName="title" color="text.primary">
          {say("chat.personal")}
        </Text>
        <Text typeName="body" color="text.secondary">
          {say("personal.what")}
        </Text>
      </Col>

      <Col testID="personal-activity">
        <Feed scope="personal" title={say("feed.recent")} limit={20} />
      </Col>

      <Col gap={3} testID="personal-conversations">
        <Row gap={1}>
          <Text typeName="bodySemibold" color="text.primary" style={{ flex: 1 }}>
            {say("project.conversations")}
          </Text>
          <Text
            typeName="caption"
            color="accent"
            testID="personal-new-conversation"
            onPress={() => void start()}
          >
            {say("project.newConversation")}
          </Text>
        </Row>
        {mine === null ? (
          <Inset pad={4}>
            <Text typeName="body" color="text.tertiary">
              {say("project.loading")}
            </Text>
          </Inset>
        ) : mine.length === 0 ? (
          <ListEmpty icon="message" line={say("project.noConversations")} />
        ) : (
          <Col>
            {mine.map((one, index) => (
              <ListRow
                key={one.id}
                testID={`personal-conversation-${one.id.slice(0, 8)}`}
                title={one.title ?? say("schedule.untitled")}
                action={one.lastAt ? <WhenLabel at={one.lastAt} /> : undefined}
                last={index === mine.length - 1}
                onPress={() => goTo(`/c/${one.id}`)}
              />
            ))}
          </Col>
        )}
      </Col>
    </PageBody>
  );
}
